'use client';

import './index.css';
import './item.css';

import { storyblokEditable } from '@storyblok/react';
import classNames from 'classnames';
import { useKeenSlider } from 'keen-slider/react';
import { useCallback, useState } from 'react';
import AnimateHeight from 'react-animate-height';

import { Image } from '@/components/image';
import { Link } from '@/components/link';
import { MaxWidth } from '@/components/max-width';

import { isImage } from '@/helpers/image';
import { KeenSliderHorizontalWheelControls } from '@/helpers/keen-slider';

export const CommentCards = ({ blok }) => {
  const [mounted, setMounted] = useState(false);

  const [sliderRef] = useKeenSlider(
    {
      loop: true,
      slides: {
        perView: 'auto',
        spacing: 24,
        origin: 'center',
      },
      breakpoints: {
        '(max-width: 768px)': {
          slides: {
            perView: 'auto',
            spacing: 16,
          },
        },
      },

      created() {
        setMounted(true);
      },
    },
    [KeenSliderHorizontalWheelControls],
  );

  return (
    <div
      {...storyblokEditable(blok)}
      className={classNames('comment-cards', {
        'comment-cards--mounted': mounted,
      })}
    >
      <MaxWidth>
        <div className="comment-cards__heading">
          {blok.rating || isImage(blok.image) ? (
            <div className="comment-cards__rating">
              <Link link={blok.link}>
                <Image
                  className="comment-cards__rating__icon"
                  image={blok.image}
                  sizes="150px"
                />
              </Link>
            </div>
          ) : null}
        </div>

        <div
          ref={sliderRef}
          className={classNames('comment-cards__cards', 'keen-slider')}
        >
          {blok.commentCardItem.map((item) => {
            return <CommentCardsItem key={item._uid} item={item} />;
          })}
        </div>
      </MaxWidth>
    </div>
  );
};

const CommentCardsItem = ({ item }) => {
  const [open, setOpen] = useState(false);

  const text = <p className="comment-cards__item__text">{item.text}</p>;

  return (
    <div
      {...storyblokEditable(item)}
      className={classNames(
        'comment-cards__item',
        { 'comment-cards__item--open': open },
        'keen-slider__slide',
      )}
    >
      <div className="comment-cards__item__info">
        <div className="comment-cards__item__profile">
          {isImage(item.image) ? (
            <Image
              className="comment-cards__item__picture"
              image={item.image}
              sizes="40px"
            />
          ) : (
            <div className="comment-cards__item__picture">
              {(item.name || '').slice(0, 1).toUpperCase()}
            </div>
          )}

          <div className="comment-cards__item__info__content">
            <p className="comment-cards__item__info__content__name">
              {item.name}
            </p>

            {item.info ? (
              <p className="comment-cards__item__info__content__info">
                {item.info}
              </p>
            ) : null}
          </div>
        </div>

        {item.rating ? (
          <div className="comment-cards__item__rating__wrapper">
            <p className="comment-cards__item__rating">{item.rating}</p>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="23"
              viewBox="0 0 22 23"
              fill="none"
            >
              <path
                d="M5.33926 20.6667L6.82884 14.2271L1.83301 9.89583L8.43301 9.32292L10.9997 3.25L13.5663 9.32292L20.1663 9.89583L15.1705 14.2271L16.6601 20.6667L10.9997 17.2521L5.33926 20.6667Z"
                fill="#FFD905"
              />
            </svg>
          </div>
        ) : null}
      </div>

      {item.text.length > 200 ? (
        <button
          type="button"
          className="comment-cards__item__button"
          onClick={() => setOpen(true)}
        >
          <AnimateHeight height={open ? 'auto' : 100}>{text}</AnimateHeight>

          {!open ? (
            <div className="comment-cards__item__toggle">
              <span>Voir plus</span>

              <img
                src="/icons/chevron-down-black.svg"
                alt=""
                width="24"
                height="24"
              />
            </div>
          ) : null}
        </button>
      ) : (
        text
      )}
    </div>
  );
};
